<template>
	<div class="hero">
		<header>
			<button @click="dropmenuButton()" class="icon-dropmenu">
				<span class="icon-left"></span>
				<span class="icon-center"></span>
				<span class="icon-right"></span>
			</button>
			<ul class="dropmenu">
				<li>
					<a href="#colazione" @click="dropmenuButton()"> Colazione </a>
				</li>

				<li>
					<a href="#caratteristiche" @click="dropmenuButton()"> Caratteristiche </a>
				</li>

				<li>
					<a href="#spazio" @click="dropmenuButton()"> Spazio </a>
				</li>

				<li>
					<a href="#muoversi" @click="dropmenuButton()"> Dove ti trovi </a>
				</li>
			</ul>
		</header>

		<main>
			<h1 class="p-5">CERAMIC HOME</h1>

			<div class="circle-cont">
				<a href="#!" class="circle" @click="contactButton()">
					<p>prenota qui</p>
				</a>
				<a href="tel:345-222-8658" class="icon top" :class="{ show: contact }">
					<font-awesome-icon icon="phone" />
				</a>
				<a
					target="_blank"
					href="https://api.whatsapp.com/send?phone=3452228658"
					class="icon top-left"
					:class="{ show: contact }"
					><font-awesome-icon icon="fa-brands fa-whatsapp"
				/></a>
				<a
					@click="copyURL('ceramicsapartmentsicily@gmail.com')"
					href="#/"
					class="icon bottom-left"
					:class="{ show: contact }"
					><font-awesome-icon icon="fa-regular fa-envelope"
				/></a>
			</div>

			<!-- <div class="slider">
				<div class="marque"><span>Benvenuti a Sciacca&nbsp;&nbsp; </span></div>
				<div class="marque marque-2">
					<span>Welcome to Sciacca&nbsp;&nbsp; </span>
				</div>
			</div> -->
		</main>
	</div>
</template>

<script>
export default {
	name: 'HeroComp',
	data() {
		return {
			dropmenu: false,
			contact: false,
		};
	},
	methods: {
		dropmenuButton() {
			if (this.dropmenu == false) {
				this.dropmenu = true;
				document.querySelector('body').style.overflow = 'hidden';
				document.querySelector('.dropmenu').classList.add('visible');
				document.querySelector('.icon-left').style.transform = 'rotate(225deg)';
				document.querySelector('.icon-right').style.transform = 'rotate(135deg)';
			} else {
				this.dropmenu = false;
				document.querySelector('body').style.overflow = 'visible';
				document.querySelector('.dropmenu').classList.remove('visible');
				document.querySelector('.icon-left').style.transform = 'rotate(0)';
				document.querySelector('.icon-right').style.transform = 'rotate(0)';
			}
		},
		contactButton() {
			this.contact = !this.contact;
		},
		async copyURL(mytext) {
			await navigator.clipboard.writeText(mytext);
			alert('Email copied');
		},
	},
};
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap');

.hero {
	width: 100%;
	height: 100vh;
	background-image: url('../assets/img/IMG_9914.JPG');
	background-size: cover;
	position: relative;
	padding-bottom: 6rem;
	text-align: center;
	header {
		position: fixed;
		z-index: 999;
		.icon-dropmenu {
			// border: 1px solid black;
			border: none;
			background-color: transparent;
			position: fixed;
			width: 50px;
			height: 30px;
			top: 20px;
			right: 20px;
			z-index: 99999;
			-webkit-box-shadow: 5px 8px 10px 7px rgba(250, 255, 71, 0.1);
			box-shadow: 5px 8px 10px 7px rgba(250, 255, 71, 0.1);

			span {
				position: absolute;
				width: 100%;
				height: 8px;
				background-color: #78b0d3;
				// border: 0.5px solid black;

				transform-origin: center;
				transition: 0.2s;

				&.icon-left {
					top: 0;
					left: 0;
				}

				&.icon-center {
					top: 10px;
					left: 0;
				}

				&.icon-right {
					top: 20px;
					left: 0;
				}
			}
		}

		.dropmenu {
			z-index: 99998;
			background-color: white;

			width: 100vw;
			height: 100%;
			//   padding: 3rem 2rem 0rem;

			position: fixed;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;

			transition: all 0.2s ease-in-out;
			filter: opacity(0);
			pointer-events: none;

			display: flex;
			flex-direction: column;
			justify-content: space-around;

			li {
				list-style: none;
				text-transform: uppercase;
				display: block;
				transition: 0.3s;

				a {
					display: block;

					font-size: 8vw;
					text-decoration: none;
					color: #78b0d3;

					transition: 0.3s;
				}
				a:hover {
					color: #507992;
				}
			}

			li:hover a {
				transform: scale(0.7);
			}
		}

		.dropmenu.visible {
			pointer-events: auto;
			filter: opacity(1);
		}
	}

	main {
		width: 100%;
		text-align: center;
		h1 {
			font-family: 'Abril Fatface', cursive;
			color: rgb(255, 255, 255);
			font-size: 12vw;
			position: absolute;
			left: 50%;
			transform: translate(-50%);
		}

		.circle-cont {
			width: 15vw;
			height: 15vw;
			min-width: 180px;
			min-height: 180px;
			position: absolute;
			top: 300px;
			right: 30px;
			.circle {
				width: 15vw;
				height: 15vw;
				min-width: 180px;
				min-height: 180px;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				background-color: #78b0d3;

				color: #ffffff;
				border: 10px solid #ffffff;

				border-radius: 100%;
				z-index: 9;
				transition: 0.2s;

				p {
					font-size: 1.2em;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					line-height: 1em;
					text-transform: uppercase;
					font-weight: bold;
					text-align: center;
				}
			}

			.circle:active {
				opacity: 0.8;
			}

			.icon {
				display: block;
				width: 50px;
				height: 50px;
				background-color: #78b0d3;
				border-radius: 50%;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				transition: 0.2s;
				opacity: 0;
				z-index: 8;

				display: flex;
				justify-content: center;
				align-items: center;

				color: rgb(255, 255, 255);
				font-size: 2em;

				.fa-whatsapp {
					font-size: 2em;
				}
			}

			.icon.show:hover {
				background-color: #365263;
			}

			.icon.show:hover .circle {
				pointer-events: none;
			}

			.icon.show {
				transform: translate(0%, 0%);
				opacity: 1;

				&.top {
					transform: translate(0%, -50%);

					top: 0%;
					left: -20%;
				}

				&.top-left {
					transform: translate(0%, -50%);

					top: 50%;
					left: -40%;
				}

				&.bottom-left {
					transform: translate(0%, -50%);

					top: 100%;
					left: -20%;
				}
			}
		}
	}
}
</style>
